import { tallyTokens } from "../../theme.tsx";
import React from "react";
import { Button, ButtonProps } from "@mui/material";

interface TallyButtonProps extends Omit<ButtonProps, "size" | "variant"> {
  size?: "small" | "medium" | "large";
  variant?: "outlined" | "contained" | "text";
  children: React.ReactNode;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const TallyButton: React.FC<TallyButtonProps> = ({
  size = "small",
  variant = "outlined",
  sx = {},
  children,
  startIcon,
  endIcon,
  ...props
}) => {
  return (
    <Button
      size={size}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={[
        {
          textTransform: "none",
          borderRadius: "1.5625rem",
          whiteSpace: "nowrap",
          fontWeight: "normal",
          minWidth: "auto",
          maxWidth: "none",
          fontSize: "0.8125rem",
          padding: "5.5px 13px",
          lineHeight: 1.35,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": { borderRadius: "1.5625rem" },
          ...(variant === "outlined" && {
            backgroundColor: tallyTokens.surface,
            borderColor: tallyTokens.line,
            color: tallyTokens.ink2,
            "&:hover": {
              borderRadius: "1.5625rem",
              backgroundColor: tallyTokens.brandWash,
              borderColor: tallyTokens.brand,
              color: tallyTokens.brandInk,
            },
          }),
        },
        // Merge any additional sx props (MUI accepts an array of sx entries).
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Button>
  );
};

export default TallyButton;
